module.exports = __webpack_public_path__ + "media/application/images/company/secondary_nav/directors-956dc39b30a85539ef301ff8a7be8db8.jpg";